$(document).ready(function() {
  $("form#order-form").trigger("reset");

  $("form#order-form").on("change", function () {
    console.log("changed")
    var selection = $(this).find("input[name='id']:checked");
    var plan = $(this).find("input[name='subscribe']:checked");
    var sellingPlanInput = $(this).find("input[name='selling_plan']");
    var sellingPlanID = $(selection).data("selling-plan");
    var handle = $(selection).data("handle");
    var numBottles = $(selection).data("num-bottles");
    var sellingPlan = $(plan).val();
    var subscription;
    var additionalSavings;
    
    switch (numBottles) {
      case 8:
        additionalSavings = "22.50";
        break;
      case 4:
        additionalSavings = "12.75";
        break;
      case 1:
        additionalSavings = "5.00";
        break;
      default: // 4 bottles
        additionalSavings = "12.75";
        break;
    }
  
    if (sellingPlan === "1") {
      subscription = true;
      sellingPlanInput.val(sellingPlanID);
    } else {
      subscription = false;
      sellingPlanInput.val("");
    }
  
    $(".additional-savings").text(additionalSavings);
    
    $.getJSON(window.Shopify.routes.root + 'products/' + handle + '.js', function(product) {
  
      var price = product.price / 100;
      var bottlePrice = price / numBottles;
      var subscriptionDiscount = (product.selling_plan_groups[0].selling_plans[0].price_adjustments[0].value) / 100;
      var subscriptionPrice = (1 - subscriptionDiscount) * bottlePrice;
  
      if (subscription) {
        $(".pro-price__new").text(subscriptionPrice.toFixed(2));
      } else {
        $(".pro-price__new").text(bottlePrice.toFixed(2));
      }
      
    });
  
    
  })
}); 

